import Cookies from "js-cookie";

export const useCookies = () => {
  const get = (key) => {
    return Cookies.get(key);
  };

  const set = (key, value, options = {}) => {
    Cookies.set(key, value, {
      SameSite: "lax",
      expires: 30,
      secure: true,
      ...options,
    });
  };

  const remove = (key) => {
    Cookies.remove(key);
  };

  return {
    get,
    set,
    remove,
  };
};
